import { render, staticRenderFns } from "./AlertAction.vue?vue&type=template&id=9e879334"
import script from "./AlertAction.vue?vue&type=script&lang=ts"
export * from "./AlertAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports